module.exports = __webpack_public_path__ + "media/Goals/CutCarbon-0484b690.svg";